import React, { forwardRef } from "react";

import { TextField } from "@mui/material";

import { BaseBadge } from "components/BaseBadge";
import BaseLabel from "components/BaseLabel";
import { IMultiLine } from "components/Multiline/interface";

import { Container, Label, LabelContainer, LabelRequired } from "./styles";
import { colors } from "../../global/globalStyle";

export interface MultilineProps {
  id?: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  rows?: number;
  required?: boolean;
  disabled?: boolean;
  error?: boolean;
  maxRows?: number;
  maxLength?: number;
}

export const Multiline = forwardRef<HTMLTextAreaElement, IMultiLine>(
  (
    {
      id,
      label,
      name,
      helperText,
      error,
      value,
      defaultValue,
      onChange,
      height = "460px",
      rows,
      maxRows,
      disabled = false,
      required = false,
      showLabelBase = true,
      maxLength,
      autofocus = false,
    },
    ref,
  ) => {
    return (
      <Container id={id} height={height}>
        {showLabelBase ? (
          <LabelContainer>
            <Label>
              <BaseLabel
                marginBottom="0px"
                marginLeft="0px"
                marginTop="0px"
                fontSize="12px"
                color={colors.neutral_gray_40}
              >
                {label}
              </BaseLabel>
            </Label>
            <LabelRequired>
              {required ? <BaseBadge color="warning" /> : <></>}
            </LabelRequired>
          </LabelContainer>
        ) : null}
        <TextField
          inputRef={ref}
          name={name}
          fullWidth
          multiline
          rows={rows}
          helperText={helperText}
          defaultValue={defaultValue}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          variant="outlined"
          className="input_mui"
          error={error}
          disabled={disabled}
          maxRows={maxRows}
          autoFocus={autofocus}
          inputProps={{
            maxLength: maxLength,
          }}
        />
      </Container>
    );
  },
);

Multiline.displayName = "Multiline";

export default Multiline;
